/* global axios */
import ApiClient from './ApiClient';

class WhatsAppBroadcastListsAPI extends ApiClient {
  constructor() {
    super('whatsapp_broadcast_lists', { accountScoped: true });
  }

  list({ inboxId }) {
    return axios.get(`${this.url}?inbox_id=${inboxId}`);
  }

  create({ inboxId, name, description, file }) {
    const formData = new FormData();
    formData.append('inbox_id', inboxId);
    formData.append('name', name);
    if (description) formData.append('description', description);
    if (file) formData.append('import_file', file);

    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  import({ id, file }) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/${id}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new WhatsAppBroadcastListsAPI();
